import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customMenu": "Обслуживание/Общая информация/Калькулятор Тех. обслуживания",
  "customPath": "/service/apps/calculator-to",
  "description": "Выберите модель, город, дилера, укажите пробег, время эксплуатации автомобиля и получите расчёт стоимости ТО. Запишитесь на ТО на официальном сайте ŠKODA.",
  "huggerTemplate": "default",
  "keywords": "",
  "name": "calculator-to",
  "title": "Калькулятор технического обслуживания (ТО) ŠKODA"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const DefSectionBtnContainer = makeShortcode("DefSectionBtnContainer");
const Button = makeShortcode("Button");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    Калькулятор технического обслуживания
  </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">Данная услуга временно недоступна.</DefaultSectionText>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button type="primary" href="/service/apps/service-form" mdxType="Button">
      записаться на сервис
    </Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      